import { Card, Tooltip } from "antd";
import classNames from "classnames";
import { Info } from "lucide-react";
import styles from "./styles.module.scss";

export interface MetricCardProps {
  icon: React.ReactNode;
  label: string;
  value: React.ReactNode;
  tooltip?: string;
  className?: string;
  compact?: boolean;
}

export function MetricCard({
  icon,
  label,
  value,
  tooltip,
  className,
  compact = false,
}: MetricCardProps) {
  return (
    <Card
      className={classNames(
        styles.metricCard,
        compact && styles.metricCardCompact,
        className
      )}
    >
      <div className={styles.metricCard__decoration} aria-hidden />
      <div className={styles.metricCard__content}>
        <div className={styles.metricCard__header}>
          <div className={styles.metricCard__icon}>{icon}</div>
          <div className={styles.metricCard__labelRow}>
            <span className={styles.metricCard__label}>{label}</span>
            {tooltip && (
              <Tooltip title={tooltip} placement="top">
                <span className={styles.metricCard__info}>
                  <Info size={13} />
                </span>
              </Tooltip>
            )}
          </div>
        </div>
        <div className={styles.metricCard__value}>{value}</div>
      </div>
    </Card>
  );
}
